import React, { useEffect, useMemo, useState } from 'react';
import { FaQrcode, FaSearch, FaShieldAlt } from 'react-icons/fa';
import { operationalEventAPI } from '../../utils/api';
import LoadingSpinner from '../../components_shared/LoadingSpinner';

const domainOptions = ['', 'logistics', 'warehouse', 'qc', 'distribution', 'finance'];

export default function OperationalTimelinePage() {
  const [rows, setRows] = useState([]);
  const [domain, setDomain] = useState('');
  const [entityType, setEntityType] = useState('');
  const [entityId, setEntityId] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const params = useMemo(() => ({
    ...(domain ? { domain } : {}),
    ...(entityType ? { entityType } : {}),
    ...(entityId ? { entityId } : {}),
    size: 100,
  }), [domain, entityType, entityId]);

  const load = async () => {
    setLoading(true);
    try {
      const res = await operationalEventAPI.list(params);
      setRows(res.data?.content || []);
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="eduss-dashboard">
      <div className="eduss-dashboard-welcome">
        <h1>Operational Event Timeline</h1>
        <p>Trace QR scans, manual overrides, delivery movement, QC, distribution, and finance actions.</p>
      </div>

      <div className="eduss-dashboard-cards-row">
        <div className="eduss-dashboard-card eduss-dashboard-card-green">
          <div className="eduss-dashboard-card-icon"><FaShieldAlt /></div>
          <div className="eduss-dashboard-card-content">
            <div className="eduss-dashboard-card-label">Events</div>
            <div className="eduss-dashboard-card-value">{loading ? '...' : rows.length}</div>
            <div className="eduss-dashboard-card-desc">Latest operational records</div>
          </div>
        </div>
        <div className="eduss-dashboard-card eduss-dashboard-card-blue">
          <div className="eduss-dashboard-card-icon"><FaQrcode /></div>
          <div className="eduss-dashboard-card-content">
            <div className="eduss-dashboard-card-label">QR Events</div>
            <div className="eduss-dashboard-card-value">{rows.filter(row => row.source === 'QR').length}</div>
            <div className="eduss-dashboard-card-desc">Actions completed by scan</div>
          </div>
        </div>
      </div>

      <div className="eduss-dashboard-content">
        <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr 160px auto', gap: 10, marginBottom: 16 }}>
          <select className="form-control" value={domain} onChange={e => setDomain(e.target.value)}>
            {domainOptions.map(option => <option key={option || 'all'} value={option}>{option || 'All domains'}</option>)}
          </select>
          <input className="form-control" value={entityType} placeholder="Entity type" onChange={e => setEntityType(e.target.value)} />
          <input className="form-control" value={entityId} placeholder="Entity ID" onChange={e => setEntityId(e.target.value)} />
          <button className="eduss-home-cta" type="button" onClick={load}><FaSearch /> Filter</button>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}
        {loading ? <LoadingSpinner /> : (
          <div style={{ overflowX: 'auto' }}>
            <table className="mini-info-table" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Domain</th>
                  <th>Entity</th>
                  <th>Action</th>
                  <th>Source</th>
                  <th>Actor</th>
                  <th>Reason</th>
                </tr>
              </thead>
              <tbody>
                {rows.map(row => (
                  <tr key={row.id}>
                    <td>{row.created_at ? new Date(row.created_at).toLocaleString() : '-'}</td>
                    <td>{row.domain}</td>
                    <td>{row.entity_type} #{row.entity_id}</td>
                    <td>{row.action}</td>
                    <td>{row.source}</td>
                    <td>{row.actor_username || '-'}</td>
                    <td>{row.override_reason || '-'}</td>
                  </tr>
                ))}
                {!rows.length && <tr><td colSpan="7">No operational events found.</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
